import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';
import { theme } from '@pairy/styles';

export const Container = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.embed};

  /* NOTE: 페이지 전체를 덮는 레이어라 임베드 영역 외 클릭은 통과시킨다 */
  pointer-events: none;
`;

export const EmbedWrapper = styled.div`
  position: absolute;
  pointer-events: auto;
  overflow: hidden;
  border-radius: 4px;
  background-color: ${theme.colors.zinc_900};

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const Facade = styled.button`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background-color: ${theme.colors.zinc_900};
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
    -webkit-user-drag: none;
  }

  /* 가림막 상태: 페이지 이미지와 동일하게 블러 처리하고 상호작용을 막는다 */
  &.is-covered {
    cursor: default;
    filter: blur(8px);
    pointer-events: none;
  }
`;

/* iframe 로딩 동안 검은 화면 대신 썸네일을 유지하다가 로드 완료 시 서서히 사라진다 */
export const LoadingCover = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.zinc_900};
  inset: 0;
  opacity: 1;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
    -webkit-user-drag: none;
  }

  &.is-hidden {
    opacity: 0;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

/* 로딩 커버 중앙의 스피너 — 영상이 로딩 중임을 인지시킨다 */
export const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: -24px 0 0 -24px;
  background-color: rgb(0 0 0 / 60%);
  color: ${theme.colors.white};

  svg {
    animation: ${spin} 1s linear infinite;
  }
`;

export const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgb(0 0 0 / 60%);
  color: ${theme.colors.white};
  transform: translate(-50%, -50%);
  transition: 0.15s ease-in-out;

  ${Facade}:hover & {
    background-color: rgb(0 0 0 / 80%);
  }
`;
